import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import AdminTable from 'common/AdminTable';
import { getRequest, deleteRequest } from 'apis/ApiInstence';
import { FaTrash, FaEdit } from 'react-icons/fa';

const BACKEND = process.env.REACT_APP_BACKEND;

const AchievementList = () => {
  const [achievementData, setAchievementData] = useState([]);
  const navigate = useNavigate();

  const fetchAchievements = async () => {
    try {
      const res = await getRequest('achievements');
      setAchievementData(res?.data || []);
    } catch (err) {
      console.error('Failed to fetch achievements:', err);
    }
  };

  useEffect(() => {
    fetchAchievements();
  }, []);

  const handleRemove = async (id) => {
    if (!window.confirm('Are you sure you want to delete this achievement?')) return;
    try {
      await deleteRequest(`achievements/${id}`);
      fetchAchievements();
    } catch (err) {
      console.error('Failed to delete achievement:', err);
    }
  };

  const tableHeaders = [
    {
      Header: 'Image',
      accessor: 'image',
      Cell: ({ row }) =>
        row.original.image ? (
          <img
            src={`${BACKEND}achievements/${row.original.image}`}
            alt="achievement"
            width={50}
            height={50}
            style={{ objectFit: 'cover', borderRadius: 4 }}
          />
        ) : (
          <span>No Image</span>
        )
    },
    { Header: 'Heading', accessor: 'heading' },
    {
      Header: 'Status',
      accessor: 'is_active',
      Cell: ({ row }) => (
        <span className={`badge ${Number(row.original.is_active) === 1 ? 'badge-success' : 'badge-secondary'}`}>
          {Number(row.original.is_active) === 1 ? 'Active' : 'Inactive'}
        </span>
      )
    },
    {
      Header: 'Actions',
      accessor: 'actions',
      Cell: ({ row }) => (
        <>
          <button
            className="btn btn-sm mx-1 text-white"
            style={{ backgroundColor: '#ffc107' }}
            onClick={() => navigate(`/achievements/update/${row.original.id}`)}
          >
            <FaEdit />
          </button>
          <button
            className="btn btn-sm mx-1 text-white"
            style={{ backgroundColor: '#dc3545' }}
            onClick={() => handleRemove(row.original.id)}
          >
            <FaTrash />
          </button>
        </>
      )
    }
  ];

  return (
    <div className="container-fluid mt-5">
      <div className="mainheadig mx-4">
        <h4 className="text-white font-weight-bold">Achievement List</h4>
      </div>
      <div className="mx-4">
        {achievementData?.length ? (
          <AdminTable tableHeaders={tableHeaders} tableData={achievementData} />
        ) : (
          <p>No achievements available.</p>
        )}
      </div>
    </div>
  );
};

export default AchievementList;
